module.exports = __webpack_public_path__ + "img/tv-hover.8c1e48bc.png";